import * as React from 'react';
import { CmsAuthor } from '@/types/author';

const AuthorContext = React.createContext<CmsAuthor | null>(null);

export const AuthorProvider = AuthorContext.Provider;

/**
 * The author referenced by the current CMS page, if any.
 *
 * Lets a CMS block render the page author without the editor having to pick one,
 * so placing the block is the only authoring step.
 */
export const useAuthor = (): CmsAuthor | null => {
	return React.useContext(AuthorContext);
};
